/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ConciergeResultsAccepted
 */
export interface ConciergeResultsAccepted {
  /**
   *
   * @type {string}
   * @memberof ConciergeResultsAccepted
   */
  status: string;
}

/**
 * Check if a given object implements the ConciergeResultsAccepted interface.
 */
export function instanceOfConciergeResultsAccepted(value: object): value is ConciergeResultsAccepted {
  if (!('status' in value) || value['status'] === undefined) return false;
  return true;
}

export function ConciergeResultsAcceptedFromJSON(json: any): ConciergeResultsAccepted {
  return ConciergeResultsAcceptedFromJSONTyped(json, false);
}

export function ConciergeResultsAcceptedFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConciergeResultsAccepted {
  if (json == null) {
    return json;
  }
  return {
    status: json['status'],
  };
}

export function ConciergeResultsAcceptedToJSON(value?: ConciergeResultsAccepted | null): any {
  if (value == null) {
    return value;
  }
  return {
    status: value['status'],
  };
}
